import { memo } from 'react';
import React from 'react';
import { useUserHasConsignorMasterUI } from 'src/hooks/useUserIsConsignorMasterUI';
import { QueryWithViewMode } from 'src/utils/eventQueryUtils';
import { EntityWithTicketsQuery } from 'src/WebApiController';

import { useTrackComponent } from '../AppPerformanceContext';
import { CatalogMetricsContextProviderProps } from './CatalogMetrics.type';
import { CatalogMetricsContextV2Provider } from './CatalogMetricsContextV2';
import { CatalogMetricsEmptyContextProvider } from './CatalogMetricsEmptyContext';

function CatalogMetricsContextProviderRaw<
  TMetrics extends { currency: string | null },
  TQuery extends EntityWithTicketsQuery & QueryWithViewMode,
>(props: CatalogMetricsContextProviderProps<TMetrics, TQuery>) {
  // If we need to test new Metrics vNext, we would add them here
  // For example:
  // return <CatalogMetricsContextV3Provider {...props} />;
  useTrackComponent('CatalogMetricsContextProviderRaw');
  const isConsignorMasterView = useUserHasConsignorMasterUI();

  return isConsignorMasterView ? (
    <CatalogMetricsEmptyContextProvider {...props} />
  ) : (
    <CatalogMetricsContextV2Provider {...props} />
  );
}

export const CatalogMetricsContextProvider = memo(
  CatalogMetricsContextProviderRaw
) as <
  TMetrics extends { currency: string | null },
  TQuery extends EntityWithTicketsQuery & QueryWithViewMode,
>(
  props: CatalogMetricsContextProviderProps<TMetrics, TQuery>
) => React.JSX.Element;
